exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hover-1-wrapper[data-v-b69a4d80]{width:210px;padding-bottom:10px}", ""]);

// exports
